// src/routes/domains/global/index.ts
import { globalRoutes } from './global.routes';
import type { AppRoute } from '../../core/types';

/**
 * Lazy export wrapper for Global routes.
 * Enables code splitting: the Global routes chunk will only load when needed.
 */
export const loadGlobalRoutes = (): Promise<AppRoute[]> => {
  return Promise.resolve(globalRoutes);
};